import React, { forwardRef } from 'react';
import TimesButton from '../TimesButton';
import type { CloseButtonProps } from './types';

/**
 * @deprecated This component is deprecated.
 * Please use `TimesButton` instead.
 */
const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(({ color, ...rest }, ref) => (
  <TimesButton ref={ref} theme={color} {...rest} />
));

CloseButton.displayName = 'CloseButton';

export default CloseButton;
